import { Box, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword } from '@/store/actions';
import { authSelector } from '@/store/selectors';

const CheckEmail = () => {
  const dispatch = useDispatch();
  const authData = useSelector(authSelector);

  return (
    <Box width={'100%'} display={'flex'} justifyContent={'center'} flexDirection={'column'} alignItems={'center'}>
      <Typography marginBottom={'1rem'} lineHeight={2} color='#1D1D1D' fontSize={'2rem'} fontWeight={'400'}>
        Check your email.
      </Typography>

      <Typography marginBottom={'1rem'} color='#000' textAlign={'center'} lineHeight={1.5} fontSize={'1.2rem'}>
        Tap the link that we sent to <strong> {authData?.email}</strong>.
      </Typography>

      <Typography color='#5C6372' fontSize={'0.688rem'}>
        Didn’t get the link?{' '}
        <a
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => {
            dispatch(forgotPassword(authData?.email));
          }}>
          Resend the email
        </a>
      </Typography>
    </Box>
  );
};

export default CheckEmail;
